<template>
  <div class="div_one">
    <el-container>
      <el-header >
        <el-row type="flex" class="row-bg" justify="center" style="background-color: #08263a">
          <!--<el-dropdown trigger="click" @command="selectOperator">
            <div style="color: rgb(191, 203, 217);font-weight: bold;font-size: large;line-height: 60px;font-size: 13px">
              {{operatorName}}
              <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
              <el-dropdown-menu slot="dropdown">
                <el-row>
                  <div>
                    <el-input size="mini"
                              v-model="operatorSelectInput"
                              placeholder="查询运营商">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </div>
                </el-row>
                <el-dropdown-item command="0">
                  全 部
                </el-dropdown-item>
                <el-dropdown-item v-for="operator in operatorsTemp" :key="operator.id"
                                  :command="operator.id+'_'+operator.name">{{operator.name}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </el-dropdown>-->
          <div style="color: rgb(191, 203, 217); font-weight: bold;font-size: large;line-height: 60px;font-size: 13px">
            <el-cascader ref="cascader"  size="" placeholder="请选择运营商" filterable
                         :options="operatorsTree"
                         :show-all-levels="false"
                         :props="{ checkStrictly: true,expandTrigger: 'hover' }"
                         @change='handChangeOperator'
                         v-model="operatorIds"
                         clearable>
            </el-cascader>
          </div>
        </el-row>
      </el-header>
      <el-main>
        <el-row :gutter="14">
          <el-col :span="12">
            <div class="div_two">
              <h5 class="h5_style">充电概览</h5>
              <div style="margin-left: 18px;">
                <el-row>
                  <div class="div_style div_bule">
                    <div>
                      <div class="fontcCloor">{{orderPart.currentYearData.totalFee}}</div>
                      <div class="fontSize">全年充电收入(元)</div>
                    </div>
                  </div>
                  <div class="div_style div_green">
                    <div>
                      <div class="fontcCloor">{{orderPart.currentMonthData.totalFee}}</div>
                      <div class="fontSize">{{currentMonth}}月充电收入(元)</div>
                    </div>
                  </div>
                  <div class="div_style div_skyblue">
                    <div>
                      <div class="fontcCloor">{{orderPart.currentDayData.totalFee}}</div>
                      <div class="fontSize">当天充电收入(元)</div>
                    </div>
                  </div>
                </el-row>
                <el-row>
                  <div class="div_style div_Orange">
                    <div>
                      <div class="fontcCloor">{{orderPart.currentYearData.totalElectricity}}</div>
                      <div class="fontSize">当年充电量(kW·h)</div>
                    </div>
                  </div>
                  <div class="div_style div_red">
                    <div>
                      <div class="fontcCloor">{{orderPart.currentMonthData.totalElectricity}}</div>
                      <div class="fontSize">{{currentMonth}}月充电量(kW·h)</div>
                    </div>
                  </div>
                  <div class="div_style div_purple">
                    <div>
                      <div class="fontcCloor">{{orderPart.currentDayData.totalElectricity}}</div>
                      <div class="fontSize">当天充电量(kW·h)</div>
                    </div>
                  </div>
                </el-row>
              </div>
              <!--充电收入曲线-->
              <el-row>
                <div class="st-gbox" style="height: 30vh;">
                  <div class="cavasbox" id="ChargeEchart"></div>
                </div>
              </el-row>
            </div>
            <!--6月充电订单来源-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <h5 class="h5_style">{{order.currentMonthOrder.month}}月充电订单来源</h5>
                  <el-row>
                    <el-col :span="9">
                      <div class="st-gbox">
                        <div class="cavasbox" id="RingDiagram"></div>
                      </div>
                    </el-col>
                    <el-col :span="14">
                      <div>
                        <div>
                          <el-row>
                            <el-col :span="8" class="el_col_one">来源</el-col>
                            <el-col :span="8" class="el_col_one">订单量</el-col>
                            <!--<el-col :span="8" class="el_col_one">总金额(元)</el-col>-->
                          </el-row>
                        </div>
                        <div style="margin-top: 15px;">
                          <div v-for="(item,index) in orderSourceMap" :key="index"
                               style="background-color: #EBEEF5;padding: 5px 0px 0px 10px">
                            <el-row style="font-size: small;">
                              <el-col :span="8">
                                <el-col :span="2"><span style="color:  #c27461;font-size:20px;">●</span></el-col>
                                {{index}}
                              </el-col>
                              <el-col :span="8">{{item}}</el-col>
                              <!--<el-col :span="8">305,324</el-col>-->
                            </el-row>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <!--6月故障总览-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <el-row style="margin-top: 10px;">
                    <el-row>
                      <h5 class="h5_style">{{currentMonth}}月故障类型汇总</h5>
                      <el-col :span="6" class="el_col_one">告警</el-col>
                      <el-col :span="6" class="el_col_one">电桩系统故障</el-col>
                      <el-col :span="6" class="el_col_one">启动充电失败</el-col>
                      <el-col :span="6" class="el_col_one">异常充电结束</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6" class="el_col_two">{{operatorAlarmRecord.alarmType4}}</el-col>
                      <el-col :span="6" class="el_col_two">{{operatorAlarmRecord.alarmType3}}</el-col>
                      <el-col :span="6" class="el_col_two">{{operatorAlarmRecord.alarmType2}}</el-col>
                      <el-col :span="6" class="el_col_two">{{operatorAlarmRecord.alarmType1}}</el-col>
                    </el-row>
                    <el-row>
                      <h5 class="h5_style">{{currentMonth}}月各故障等级汇总</h5>
                      <div class="div_two">
                        <div class="st-gbox st-gbox_two">
                          <div class="canvanbox" id="FaultEcharts"></div>
                        </div>
                      </div>
                    </el-row>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <!--互联互通场站-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <el-row>
                    <h5 class="h5_style">互联互通场站</h5>
                    <el-row>
                      <el-col :span="6" class="el_col_one">总场站</el-col>
                      <el-col :span="6" class="el_col_one">总充电桩</el-col>
                      <el-col :span="6" class="el_col_one">总充电枪</el-col>
                      <el-col :span="6" class="el_col_one">总功率</el-col>
                      <!--<el-col :span="6" class="el_col_one">城市分布</el-col>-->
                    </el-row>
                    <el-row>
                      <el-col :span="6" class="el_col_two">{{res.opertorCecRes.stationNum}}</el-col>
                      <el-col :span="6" class="el_col_two">{{res.opertorCecRes.pileNum}}</el-col>
                      <el-col :span="6" class="el_col_two">{{res.opertorCecRes.gunNum}}<span
                        style="font-size: 20px;">个</span></el-col>
                      <el-col :span="6" class="el_col_two">{{res.opertorCecRes.totalPower}}<span
                        style="font-size: 20px;">kw</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorCecRes.increStationNum}}</span></el-col>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorCecRes.increPileNum}}</span></el-col>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorCecRes.increGunNum}}个</span></el-col>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorCecRes.increPower}}kw</span></el-col>
                    </el-row>
                  </el-row>
                  <div style="padding-bottom: 10px;">
                    <el-row>
                      <h5 class="h5_style">互联互通充电收入&充电量</h5>
                    </el-row>
                    <div style="margin-left: 18px;">
                      <el-row>
                        <div class="div_style div_bule">
                          <div>
                            <div class="fontcCloor">{{order.currentYearCecOrder.totalFee}}</div>
                            <div class="fontSize">全年充电收入(元)</div>
                          </div>
                        </div>
                        <div class="div_style div_green">
                          <div>
                            <div class="fontcCloor">{{order.currentMonthCecOrder.totalFee}}</div>
                            <div class="fontSize">{{order.currentMonthOrder.month}}月充电收入(元)</div>
                          </div>
                        </div>
                        <div class="div_style div_skyblue">
                          <div>
                            <div class="fontcCloor">{{order.yesterdayCecOrder.totalFee}}</div>
                            <div class="fontSize">昨天充电收入(元)</div>
                          </div>
                        </div>
                      </el-row>
                      <el-row>
                        <div class="div_style div_Orange">
                          <div>
                            <div class="fontcCloor">{{order.currentYearCecOrder.totalFee}}</div>
                            <div class="fontSize">全年充电量(kW·h)</div>
                          </div>
                        </div>
                        <div class="div_style div_red">
                          <div>
                            <div class="fontcCloor">{{order.currentMonthCecOrder.totalFee}}</div>
                            <div class="fontSize">{{order.currentMonthOrder.month}}月充电量(kW·h)</div>
                          </div>
                        </div>
                        <div class="div_style div_purple">
                          <div>
                            <div class="fontcCloor">{{order.yesterdayCecOrder.totalFee}}</div>
                            <div class="fontSize">昨天充电量(kW·h)</div>
                          </div>
                        </div>
                      </el-row>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!--6月个人会员概览-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <h5 class="h5_style">{{currentMonth}}月个人会员概览</h5>
                  <div style="margin-left: 18px;">
                    <el-row>
                      <div class="div_style_one div_green">
                        <div class="fontStyle_three">
                          <div class="fontStyle_one">个人会员(人)</div>
                          <div class="fontStyle_two">{{customerNumber.customerNum}}</div>
                        </div>
                      </div>
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总营业额(元)</div>
                          <div class="fontStyle_five">{{orderPart.currentMonthData.totalFee}}</div>
                        </div>
                      </div>
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总充电量(kW·h)</div>
                          <div class="fontStyle_five">{{orderPart.currentMonthData.totalElectricity}}</div>
                        </div>
                      </div>
                    </el-row>
                    <el-row>
                      <div class="div_style_one div_green">
                        <div class="fontStyle_three">
                          <div class="fontStyle_one">{{currentMonth}}月新增(人)</div>
                          <div class="fontStyle_two">{{customerNumber.newCustomerNum}}</div>
                        </div>
                      </div>
                      <!--<div class="div_style_one">-->
                        <!--<div class="fontStyle_three">-->
                          <!--<div class="fontStyle_four">充电人数(人)</div>-->
                          <!--<div class="fontStyle_five">{{order.currentMonthOrder.chargeCustomerNum}}</div>-->
                        <!--</div>-->
                      <!--</div>-->
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总充电次数(次)</div>
                          <div class="fontStyle_five">{{orderPart.currentMonthData.orderNum}}</div>
                        </div>
                      </div>
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总服务费(元)</div>
                          <div class="fontStyle_five">{{orderPart.currentMonthData.serviceFee}}</div>
                        </div>
                      </div>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!--6月集团会员概览-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <h5 class="h5_style">{{currentMonth}}月集团会员概览</h5>
                  <div style="margin-left: 18px;">
                    <el-row>
                      <div class="div_style_one div_bule">
                        <div class="fontStyle_three">
                          <div class="fontStyle_one">集团数量(个)</div>
                          <div class="fontStyle_two">{{customerNumber.groupNum}}</div>
                        </div>
                      </div>
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总收入(元)</div>
                          <div class="fontStyle_five">{{orderPart.groupMonthData.totalFee}}</div>
                        </div>
                      </div>
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总充电量(kW·h)</div>
                          <div class="fontStyle_five">{{orderPart.groupMonthData.totalElectricQuantity}}</div>
                        </div>
                      </div>
                    </el-row>
                    <el-row>
                      <div class="div_style_one div_bule">
                        <div class="fontStyle_three">
                          <div class="fontStyle_one">集团会员(人)</div>
                          <div class="fontStyle_two">{{customerNumber.groupCustomerNum}}</div>
                        </div>
                      </div>
                      <!--<div class="div_style_one">-->
                        <!--<div class="fontStyle_three">-->
                          <!--<div class="fontStyle_four">充电人数(人)</div>-->
                          <!--<div class="fontStyle_five">{{order.currentMonthOrder.chargeGroupNum}}</div>-->
                        <!--</div>-->
                      <!--</div>-->
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总充电次数(次)</div>
                          <div class="fontStyle_five">{{orderPart.groupMonthData.totalOrderNumber}}</div>
                        </div>
                      </div>
                      <div class="div_style_one">
                        <div class="fontStyle_three">
                          <div class="fontStyle_four">总服务费(元)</div>
                          <div class="fontStyle_five">{{orderPart.groupMonthData.totalServiceFee}}</div>
                        </div>
                      </div>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <div>
              <!--设备实时状态-->
              <div>
                <el-row>
                  <div class="div_two">
                    <h5 class="h5_style">设备实时状态</h5>
                    <el-row>
                      <el-col :span="6" class="el_col_one"><span style="color: #409EFF;" class="span_one">●</span>充电中枪口
                      </el-col>
                      <el-col :span="6" class="el_col_one"><span style="color:  #43c26e" class="span_one">●</span>空闲枪口
                      </el-col>
                      <el-col :span="6" class="el_col_one"><span style="color: #BDC1C2" class="span_one">●</span>离线枪口
                      </el-col>
                      <el-col :span="6" class="el_col_one"><span style="color: #ffbc2e" class="span_one">●</span>故障枪口
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6" class="el_col_two">{{gunRealTimeStatistics.chargingGunNum}}</el-col>
                      <el-col :span="6" class="el_col_two">{{gunRealTimeStatistics.freeGunNum}}</el-col>
                      <el-col :span="6" class="el_col_two">{{gunRealTimeStatistics.offlineGunNum}}</el-col>
                      <el-col :span="6" class="el_col_two">{{gunRealTimeStatistics.badGunNum}}</el-col>
                    </el-row>
                  </div>
                </el-row>
              </div>
              <!--自营场站概览-->
              <div style="margin-top: 20px;">
                <el-row>
                  <div class="div_two">
                    <h5 class="h5_style">自营场站概览</h5>
                    <el-row>
                      <el-col :span="6" class="el_col_one">电站总数量</el-col>
                      <el-col :span="6" class="el_col_one">电桩总数量</el-col>
                      <el-col :span="6" class="el_col_one">电枪总数量</el-col>
                      <el-col :span="6" class="el_col_one">总功率(kW)</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6" class="el_col_three">{{selfStationStatistics.stationNum}}</el-col>
                      <el-col :span="6" class="el_col_three">{{selfStationStatistics.pileNum}}</el-col>
                      <el-col :span="6" class="el_col_three">{{selfStationStatistics.gunNum}}</el-col>
                      <el-col :span="6" class="el_col_three">{{selfStationStatistics.totalPower}}</el-col>
                    </el-row>
                    <!--<el-row>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorRes.increStationNum}}</span></el-col>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorRes.increPileNum}}</span></el-col>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorRes.increGunNum}}</span></el-col>
                      <el-col :span="6" class="el_col_four">{{order.currentMonthOrder.month}}月新增<span
                        class="span_margin">{{res.opertorRes.increPower}}kw</span></el-col>
                    </el-row>-->
                  </div>
                </el-row>
              </div>
            </div>
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <div class="st-gbox st-gbox_one">
                    <div class="canvanbox" id="IncomeEchart"></div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!--6月场站充电量概览-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <div style="margin-top: 20px;">
                    <el-row>
                      <!--<h5 class="h5_style">当月场站充电量概览</h5>
                      <div style="margin:0px 15px 20px 15px">
                      <el-row>
                        <el-col :span="8">
                          <el-row style="margin-top: 10px;">
                            <el-col :span="8" class="el_col_one">总充电量(kW·h)</el-col>
                            &lt;!&ndash;<el-col :span="12" class="el_col_one">目标充电量(kW·h)</el-col>&ndash;&gt;
                          </el-row>
                          <el-row style="margin-top: 10px;">
                            <el-col :span="8" class="el_col_two">{{stationRanking.stationCurrentMonthTotal.totalElectricQuantity}}</el-col>
                            &lt;!&ndash;<el-col :span="12" class="el_col_two">987,768</el-col>&ndash;&gt;
                          </el-row>
                        </el-col>
                        <el-col :span="6">
                        <el-row style="margin-top: 10px;">
                          <el-col :span="6" class="el_col_one">总收入(元)</el-col>
                          &lt;!&ndash;<el-col :span="12" class="el_col_one">目标充电量(kW·h)</el-col>&ndash;&gt;
                        </el-row>
                        <el-row style="margin-top: 10px;">
                          <el-col :span="6" class="el_col_two">{{stationRanking.stationCurrentMonthTotal.totalFee}}</el-col>
                          &lt;!&ndash;<el-col :span="12" class="el_col_two">987,768</el-col>&ndash;&gt;
                        </el-row>
                      </el-col>
                      <el-col :span="6">
                        <el-row style="margin-top: 10px;">
                          <el-col :span="6" class="el_col_one">订单数量</el-col>
                          &lt;!&ndash;<el-col :span="12" class="el_col_one">目标充电量(kW·h)</el-col>&ndash;&gt;
                        </el-row>
                        <el-row style="margin-top: 10px;">
                          <el-col :span="6" class="el_col_two">{{stationRanking.stationCurrentMonthTotal.totalOrderNumber}}</el-col>
                          &lt;!&ndash;<el-col :span="12" class="el_col_two">987,768</el-col>&ndash;&gt;
                        </el-row>
                      </el-col>
                        &lt;!&ndash;<el-col :span="8">
                          <div>
                            <el-progress type="circle" :percentage="99.8" :show-text="true" :stroke-width="10"></el-progress>
                          </div>
                        </el-col>&ndash;&gt;
                      </el-row>
                      </div>-->
                      <el-row>
                        <div class="div_two">
                          <h5 class="h5_style">{{currentMonth}}月场站充电量概览</h5>
                          <el-row>
                            <el-col :span="6" class="el_col_one">总充电量(kW·h)</el-col>
                            <el-col :span="6" class="el_col_one">总营业额(元)</el-col>
                            <el-col :span="6" class="el_col_one">订单数量(笔)</el-col>
                            <el-col :span="6" class="el_col_one">利用率(%)</el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="6" class="el_col_exit">{{stationRanking.stationCurrentMonthTotal.totalElectricQuantity}}</el-col>
                            <el-col :span="6" class="el_col_exit">{{stationRanking.stationCurrentMonthTotal.totalFee}}</el-col>
                            <el-col :span="6" class="el_col_exit">{{stationRanking.stationCurrentMonthTotal.totalOrderNumber}}</el-col>
                            <el-col :span="6" class="el_col_exit">{{stationRanking.stationCurrentMonthTotal.usedRate}}</el-col>
                          </el-row>
                        </div>
                      </el-row>
                      <!--6月场站充电量排行-->
                      <el-row>
                        <h5 class="h5_style">{{currentMonth}}月场站充电量排行</h5>
                        <div style="margin:0px 15px 20px 15px">
                          <el-table :data="stationRanking.stationCurrentMonthRanking" style="width: 100%"
                                    :row-class-name="tableRowClassName">
                            <af-table-column prop="stationName" label="场站名"></af-table-column>
                            <af-table-column prop="totalElectricQuantity" label="充电量(kW·h)" width="140"></af-table-column>
                            <af-table-column prop="totalFee" label="营业额(元)" width="140"></af-table-column>
                            <af-table-column prop="totalOrderNumber" label="订单量(单)" width="100"></af-table-column>
                            <af-table-column prop="usedRate" label="利用率(%)" width="80"></af-table-column>
                            <!--<af-table-column prop="address" label="目标充电量(kW·h)"></af-table-column>-->
                            <!--<af-table-column prop="address" label="达成率"></af-table-column>-->
                          </el-table>
                        </div>
                      </el-row>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <h5 class="h5_style">效率</h5>
                  <div style="margin-left: 18px;">
                    <el-row>
                      <div>
                        <el-col :span="12">
                          <div style="margin-bottom: 20px;">
                            <!--利用率-->
                            <h5>充电时长(当天)</h5>
                            <el-row style="font-size: small">
                              <!--<el-col :span="10">日</el-col>-->
                              <el-col :span="24">{{orderPart.chargeLength}}</el-col>
                              <!--<el-col :span="8"><i class="el-icon-bottom span_green"></i></el-col>-->
                            </el-row>
                            <div style="font-size: small;color: #B6B6C2;margin-top: 10px;">利用率</div>
                            <el-progress type="circle" :percentage="orderPart.usedRate" :show-text="true"
                                         :stroke-width="8"></el-progress>

                            <!--<el-row style="margin-top: 5px;font-size: small">-->
                              <!--<el-col :span="10">月</el-col>-->
                              <!--<el-col :span="6">{{order.currentMonthOrder.chargeLength}}</el-col>-->
                              <!--<el-col :span="8"><i class="el-icon-bottom span_green"></i></el-col>-->
                            <!--</el-row>-->
                            <!--<el-row style="margin-top: 5px;font-size: small">-->
                              <!--<el-col :span="10">年</el-col>-->
                              <!--<el-col :span="6">{{order.currentYearOrder.chargeLength}}</el-col>-->
                              <!--<el-col :span="8"><i class="el-icon-bottom span_green"></i></el-col>-->
                            <!--</el-row>-->
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div>
                            <!--准确率-->
                            <h5>充电枪在线率</h5>
                            <!--<h5>丢单设备/运营设备(台)</h5>-->
                            <el-row style="font-size: small">
                              <!--<el-col :span="6">日</el-col>-->
                              <el-col :span="24">{{gunRealTimeStatistics.onlineGunNum}}个</el-col>
                              <!--<el-col :span="6">-->
                                <!--&lt;!&ndash;<el-col :span="8"><i class="el-icon-minus span_green"></i></el-col>&ndash;&gt;-->
                                <!--<el-col :span="5"><span>/</span></el-col>-->
                                <!--<el-col :span="5"><span>{{order.currentDayOrder.orderNum}}</span></el-col>-->
                              <!--</el-col>-->
                              <!--<el-col :span="6"><i class="el-icon-minus span_green"></i></el-col>-->
                            </el-row>
                            <div style="font-size: small;color: #B6B6C2;margin-top: 10px;">实时在线率</div>
                            <el-progress type="circle" :percentage="gunRealTimeStatistics.onlineRate" :show-text="true" :stroke-width="8"
                                         :color="colorStyle"></el-progress>
                            <!--<el-row style="margin-top: 5px;font-size: small">-->
                              <!--<el-col :span="6">月</el-col>-->
                              <!--<el-col :span="6">{{order.currentMonthOrder.loseOrderNum}}</el-col>-->
                              <!--<el-col :span="6">-->
                                <!--<el-col :span="8"><i class="el-icon-minus span_red"></i></el-col>-->
                                <!--<el-col :span="5"><span>/</span></el-col>-->
                                <!--<el-col :span="5"><span>{{order.currentMonthOrder.orderNum}}</span></el-col>-->
                              <!--</el-col>-->
                              <!--<el-col :span="6"><i class="el-icon-top span_red"></i></el-col>-->
                            <!--</el-row>-->
                            <!--<el-row style="margin-top: 5px;font-size: small">-->
                              <!--<el-col :span="6">年</el-col>-->
                              <!--<el-col :span="6">{{order.currentYearOrder.loseOrderNum}}</el-col>-->
                              <!--<el-col :span="6">-->
                                <!--<el-col :span="8"><i class="el-icon-bottom span_green"></i></el-col>-->
                                <!--<el-col :span="5"><span>/</span></el-col>-->
                                <!--<el-col :span="5"><span>{{order.currentYearOrder.orderNum}}</span></el-col>-->
                              <!--</el-col>-->
                              <!--<el-col :span="6"><i class="el-icon-minus span_green"></i></el-col>-->
                            <!--</el-row>-->
                          </div>
                          <!--转换率-->
                          <!--<div>
                            <el-progress type="circle"  :percentage="79" :show-text="true" :stroke-width="8" :color="colorStyle"></el-progress>
                            <div style="font-size: small;color: #B6B6C2;">转换率</div>
                            <h5>充电量/用电量(MWh)</h5>
                            <el-row style="font-size: small">
                              <el-col :span="6">日</el-col>
                              <el-col :span="6">15</el-col>
                              <el-col :span="6">
                                <el-col :span="8"><i class="el-icon-bottom span_green"></i></el-col>
                                <el-col :span="5"><span>/</span></el-col>
                                <el-col :span="5"><span>15</span></el-col>
                              </el-col>
                              <el-col :span="6"><i class="el-icon-bottom span_green"></i></el-col>
                            </el-row>
                            <el-row style="margin-top: 5px;font-size: small">
                              <el-col :span="6">周</el-col>
                              <el-col :span="6">121</el-col>
                              <el-col :span="6">
                                <el-col :span="8"><i class="el-icon-bottom" style=""></i></el-col>
                                <el-col :span="5"><span>/</span></el-col>
                                <el-col :span="5"><span>125</span></el-col>
                              </el-col>
                              <el-col :span="6"><i class="el-icon-top span_red"></i></el-col>
                            </el-row>
                            <el-row style="margin-top: 5px;font-size: small">
                              <el-col :span="6">月</el-col>
                              <el-col :span="6">579</el-col>
                              <el-col :span="6">
                                <el-col :span="8"><i class="el-icon-bottom span_green"></i></el-col>
                                <el-col :span="5"><span>/</span></el-col>
                                <el-col :span="5"><span>599</span></el-col>
                              </el-col>
                              <el-col :span="6"><i class="el-icon-bottom span_green"></i></el-col>
                            </el-row>
                          </div>-->
                        </el-col>
                      </div>
                    </el-row>
                    <!--<el-row>
                      <div>
                        <el-col :span="12">
                          <div style="margin-bottom: 20px;">
                            &lt;!&ndash;在线率&ndash;&gt;
                            <h5>在线充电枪</h5>
                            <el-row style="font-size: small">
                              &lt;!&ndash;<el-col :span="6">日</el-col>&ndash;&gt;
                              <el-col :span="24">gunRealTimeStatistics.onlineGunNum个</el-col>
                              <el-col :span="24"></el-col>
                              &lt;!&ndash;<el-col :span="6">&ndash;&gt;
                              &lt;!&ndash;&lt;!&ndash;<el-col :span="8"><i class="el-icon-bottom span_green"></i></el-col>&ndash;&gt;&ndash;&gt;
                              &lt;!&ndash;<el-col :span="5"><span>/</span></el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="5"><span>{{res.gunHour.totalGunNum}}</span></el-col>&ndash;&gt;
                              &lt;!&ndash;</el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6"><i class="el-icon-minus span_green"></i></el-col>&ndash;&gt;
                            </el-row>
                            <div style="font-size: small;color: #B6B6C2;">在线率</div>
                            <el-progress type="circle" :percentage="gunRealTimeStatistics.onlineRate" :show-text="true" :stroke-width="8"
                                         :color="colorStyle"></el-progress>
                            &lt;!&ndash;<h5>在线设备/运营设备(台)</h5>&ndash;&gt;

                            &lt;!&ndash;<el-row style="margin-top: 5px;font-size: small">&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6">月</el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6">{{res.gunHour.totalGunNum-res.gunHour.offlineGunNum}}</el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6">&ndash;&gt;
                                &lt;!&ndash;<el-col :span="8"><i class="el-icon-bottom span_red"></i></el-col>&ndash;&gt;
                                &lt;!&ndash;<el-col :span="5"><span>/</span></el-col>&ndash;&gt;
                                &lt;!&ndash;<el-col :span="5"><span>{{res.gunHour.totalGunNum}}</span></el-col>&ndash;&gt;
                              &lt;!&ndash;</el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6"><i class="el-icon-top span_red" ></i></el-col>&ndash;&gt;
                            &lt;!&ndash;</el-row>&ndash;&gt;
                            &lt;!&ndash;<el-row style="margin-top: 5px;font-size: small">&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6">年</el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6">{{res.gunHour.totalGunNum-res.gunHour.offlineGunNum}}</el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6">&ndash;&gt;
                                &lt;!&ndash;<el-col :span="8"><i class="el-icon-minus span_green"></i></el-col>&ndash;&gt;
                                &lt;!&ndash;<el-col :span="5"><span>/</span></el-col>&ndash;&gt;
                                &lt;!&ndash;<el-col :span="5"><span>{{res.gunHour.totalGunNum}}</span></el-col>&ndash;&gt;
                              &lt;!&ndash;</el-col>&ndash;&gt;
                              &lt;!&ndash;<el-col :span="6"><i class="el-icon-minus span_green"></i></el-col>&ndash;&gt;
                            &lt;!&ndash;</el-row>&ndash;&gt;
                          </div>
                        </el-col>
                        <el-col :span="12">

                        </el-col>
                      </div>
                    </el-row>-->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script type="text/ecmascript-6">
  import Chart from 'echarts'
  import operatingViewOperatorApi from '../../monitoringCenter/api/operatingViewOperatorApi'
  import {second2Time} from '@/common/validUtil.js';
  import commonApi from '@/common/api/commonFromVuexApi.js'
  import comApi from '@/common/api/commonApi.js';

  export default {
    name: 'OperatingViewOperator',
    data() {
      return {
        operatorsTree: [],
        operatorIds: [],
        currentMonth:'',
        orderSourceMap: {},
        order: {
          currentDayCecOrder: {},
          currentDayOrder: {},
          currentMonthCecOrder: {},
          currentMonthOrder: {},
          currentYearCecOrder: {},
          currentYearOrder: {},
          dailyOrderList: {},
          monthlyOrderList: {},
          operatorStationDailyList: [],
          orderSource: {},
          totalOrder: {},
          utilization: 0,
          chargeLength:0,
          yesterdayCecOrder: {},
          yesterdayOrder: {},
          accuracy: 0
        },
        totalFee:0,
        member: {},
        ops: {
          alarmTypes: {},
          alarmStatistic: {}
        },
        res: {
          gunHour: {},
          opertorRes: {},
          opertorCecRes: {}
        },
        gunRealTimeStatistics:{},
        selfStationStatistics:{},
        orderPart:{
          currentDayData:{},
          currentMonthData:{},
          currentYearData:{},
          groupMonthData:{},
          chargeLength:'0时0分0秒',
          usedRate:0
        },
        sixMonthData:[],
        stationRanking:{
          stationCurrentMonthTotal:{},
          stationCurrentMonthRanking:[]
        },
        customerNumber:{
          customerNum:0,
          newCustomerNum:0,
          groupNum:0,
          groupCustomerNum:0
        },
        operatorAlarmRecord:{
          alarmLevelData:{},
          alarmTypeData:{},
          alarmType1:0,
          alarmType2:0,
          alarmType3:0,
          alarmType4:0
        },
        selectForm:{},
        colorStyle: [
          // {color: '#f56c6c', percentage: 20},
          // {color: '#e6a23c', percentage: 40},
          {color: '#5cb87a', percentage: 80},
          {color: '#e6a23c', percentage: 90},
          {color: '#f56c6c', percentage: 100}
        ],
        selectedOperatorId: '0',
        operators: {},
        operatorSelectInput: '',
        operatorName: ' 全 部 ',
        operatorsTemp:''
      }
    },
    // 导入组件
    components: {},
    // 里面的函数只有调用才会执行
    methods: {
      //获取运营商树
      getOperatorsTree() {
        let params = JSON.stringify({});
        comApi.getOperatorsTree(params).then((res) => {
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(val){
        let selectedOperatorId = val && val.length>0 ? val[val.length-1] : '0'
        this.selectedOperatorId = selectedOperatorId
        this.getRingStatistics()
        this.$refs.cascader.dropDownVisible = false
      },
      initCurrentMonth(){
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth()+1;
        this.currentMonth = yy+"-"+mm;
      },
      //加载运营商列表
      loadOperators() {
        commonApi.getOperators().then((res) => {
          this.operators = res
          this.operatorsTemp = res.slice(0,10)
        })
      },
      selectOperator(command, event) {
        this.operatorName = event.$el.innerText
        this.selectedOperatorId = command.substr(0, 18)
        this.getRingStatistics()
      },
      // 环形图-- 6月充电订单来源
      getRing() {
        this.chart = Chart.init(document.getElementById('RingDiagram'));
        let myMap = {}
        for (let i = 0; i < this.order.orderSource.length; i++) {
          if(myMap.hasOwnProperty(this.order.orderSource[i].orderSource)){
            myMap[this.order.orderSource[i].orderSource] =  myMap[this.order.orderSource[i].orderSource] + this.order.orderSource[i].orderNum
          }else{
            myMap[this.order.orderSource[i].orderSource] = this.order.orderSource[i].orderNum
          }
        }
        this.orderSourceMap = myMap
        let data = [0]
        let mapIndex = 0
        for (let key in myMap) {
          data[mapIndex] = {
            value:myMap[key],
            name:key
          }
          mapIndex = mapIndex + 1
        }
        this.chart.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          // legend: {
          //   orient: 'vertical',
          //   x: 'left',
          //   data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
          // },
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '14',
                    fontWeight: 'bold'
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: data
            }
          ]
        })
      },
      // 充电收入曲线
      getCharge() {
        this.chart = Chart.init(document.getElementById('ChargeEchart'))
        let xdata = []
        let ydataFee = []
        let ydataElectricity = []
        for (let i = 0; i < this.order.dailyOrderList.length; i++) {
          xdata[i] = this.order.dailyOrderList[i].batchTime
          ydataFee[i] = this.order.dailyOrderList[i].totalFee
          ydataElectricity[i] = this.order.dailyOrderList[i].totalElectricQuantity
        }
        this.chart.setOption({

          title: {
            text: '充电收入',
            textStyle: {
              fontSize: 14
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['电量', '收入'],
            top: 1,
            left: 450,
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              fontSize: 12,
              color: '#323232'
            }
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 40,
            borderWidth: 1
          },
          xAxis: {
            type: 'category',
            data: xdata,
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#999999',
                width: 1
              }
            },
            axisLabel: {
              rotate:30,
              margin: 14,
              height: 70,
              interval: 0,
              textStyle: {
                fontSize: 10,
                color: '#999999'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#999999',
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: '#999999'
              }
            }
          },
          series: [
            {
              name: '电量',
              type: 'line',
              barGap: 0,
              data: ydataElectricity,
              barWidth: 10,
              itemStyle: {
                color: '#108ff9'
              }
            },
            {
              name: '收入',
              type: 'line',
              stack: '总量',
              barWidth: 10,
              data: ydataFee
            }
          ]
        })
      },
      // 收入分布
      getIncome() {
        let xData = [];
        let totalFee = [];
        let totalElec = [];
        let groupFee = [];
        let groupElec = [];
        this.chart = Chart.init(document.getElementById('IncomeEchart'));
        for (let i = 0; i < this.sixMonthData.length; i++) {
            xData[i] = this.sixMonthData[i].batchTime;
            totalFee[i] = this.sixMonthData[i].stationFee;
            totalElec[i] = this.sixMonthData[i].stationElectricQuantity;
            groupFee[i] = this.sixMonthData[i].groupFee;
            groupElec[i] = this.sixMonthData[i].groupElectricQuantity;
        }
        this.chart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: ['总营业额', '总充电量', '集团营业额', '集团充电量']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },

          xAxis: [{
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate:30
            },
            data: xData
          }],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '总营业额',
              type: 'bar',
              stack: '总营业额',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: totalFee
            },
            {
              name: '总充电量',
              type: 'bar',
              stack: '总充电量',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: totalElec
            },
            {
              name: '集团营业额',
              type: 'bar',
              stack: '集团营业额',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: groupFee
            },
            {
              name: '集团充电量',
              type: 'bar',
              stack: '集团充电量',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: groupElec
            }
          ]
        })
      },
      // 6月故障概览
      getFault() {
        let xdata = [];
        let ydata = [];
        if(this.operatorAlarmRecord.alarmLevelData.length > 0){
          for (let i = 0; i < this.operatorAlarmRecord.alarmLevelData.length; i++) {
            let level = this.operatorAlarmRecord.alarmLevelData[i].alarmLevel;
            let xLevel = "";
            if(level ==="1"){
              xLevel = "一级";
            }else if(level ==="2"){
              xLevel = "二级";
            }else if(level ==="3"){
              xLevel = "三级";
            }else{
              xLevel = "四级";
            }
            xdata[i] = xLevel;
            ydata[i] = this.operatorAlarmRecord.alarmLevelData[i].alarmNumber;
          }
        }else{
          ydata = [0,0,0,0];
          xdata = ['一级','二级','三级','四级'];
        }
        this.chart = Chart.init(document.getElementById('FaultEcharts'));
        this.chart.setOption({
          title: {
            //text: '告警等级'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 10]
          },
          yAxis: {
            type: 'category',
            data: xdata,
            axisLabel: {
              margin: 14,
              textStyle: {
                fontSize: 13,
                color: '#999999'
              }
            }
          },
          series: [
            {
              name: '数量',
              type: 'bar',
              data: ydata
            }
          ]
        })
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex % 2 == 0) {
          return 'warning-row'
        } else if (rowIndex % 2 == 1) {
          return 'success-row'
        }
        return ''
      },
      async getRingStatistics() {
        // let operatorId = this.$store.getters.operatorIds[0]
        let operatorId = this.selectedOperatorId;
        operatingViewOperatorApi.getRingStatistics(operatorId).then((res) => {
          if (res) {
            this.order = res.operatorOrder;
            this.member = res.operatorMember;
            this.ops = res.operatorOps;
            this.res = res.operatorRes
          } else {
          }
        });
        /*充电站部分*/
        if(operatorId==='0') operatorId = '';
        this.selectForm.operatorId = operatorId;
        let param = JSON.stringify(this.selectForm);
        await operatingViewOperatorApi.getGunRealTimeStatistics(param).then((res) => {
          if (res) {
            this.gunRealTimeStatistics = res.gunRealTimeStatistics;
            this.selfStationStatistics = res.selfStationStatistics;
          }
        });
        /*订单收入部分*/
        operatingViewOperatorApi.getOrderStatisticsV2(param).then((res) => {
          if (res) {
            this.orderPart.currentDayData = res.currentDayData;
            this.orderPart.currentMonthData = res.currentMonthData;
            this.orderPart.currentYearData = res.currentYearData;
            this.orderPart.groupMonthData = res.groupMonthData;
            this.orderPart.chargeLength = second2Time(res.currentDayData.chargeLength);
            console.info("chargeLength:"+res.currentDayData.chargeLength+"chargingGunNum:"+this.gunRealTimeStatistics.chargingGunNum+",freeGunNum:"+this.gunRealTimeStatistics.freeGunNum)
            this.orderPart.usedRate = (Math.round(res.currentDayData.chargeLength / (86400*(this.gunRealTimeStatistics.chargingGunNum+this.gunRealTimeStatistics.freeGunNum)) * 10000) / 100.00);
          }
        });
        /*充电概览及排行前10*/
        operatingViewOperatorApi.getOperatorStationRanking(param).then((res) => {
          if (res.code === 0) {
            this.stationRanking.stationCurrentMonthTotal = res.data.stationCurrentMonthTotal;
            this.stationRanking.stationCurrentMonthRanking = res.data.stationCurrentMonthRanking;
          }else{
            console.log("充电概览及排行榜，数据获取异常");
          }
        });
        /*当月故障总览*/
        operatingViewOperatorApi.getOperatorAlarm(param).then((res) => {
          if (res.code === 0) {
            this.operatorAlarmRecord.alarmLevelData = res.data.alarmLevelData;
            this.operatorAlarmRecord.alarmTypeData = res.data.alarmTypeData;
            if(res.data.alarmTypeData.length > 0){
              for (let i = 0; i < res.data.alarmTypeData.length; i++) {
                let s = res.data.alarmTypeData[i];
                if(s.alarmType ==='exce_end'){
                  this.operatorAlarmRecord.alarmType1 = s.alarmTypeNumber;
                }else if(s.alarmType ==='start_fail'){
                  this.operatorAlarmRecord.alarmType2 = s.alarmTypeNumber;
                }else if(s.alarmType ==='system_error'){
                  this.operatorAlarmRecord.alarmType3 = s.alarmTypeNumber;
                }else if(s.alarmType ==='alarm'){
                  this.operatorAlarmRecord.alarmType4 = s.alarmTypeNumber;
                }
              }
            }else{
              this.operatorAlarmRecord.alarmType1 = 0;
              this.operatorAlarmRecord.alarmType2 = 0;
              this.operatorAlarmRecord.alarmType3 = 0;
              this.operatorAlarmRecord.alarmType4 = 0;
            }
          }else{
            console.log("充电告警概览，数据获取异常");
          }
        });
        operatingViewOperatorApi.getCustomerStatisticsData(param).then((res) => {
          console.log(res);
          if (res.code === 0) {
              this.customerNumber.customerNum = res.data.customerNum;
              this.customerNumber.newCustomerNum = res.data.newCustomerNum;
              this.customerNumber.groupNum = res.data.groupNum;
              this.customerNumber.groupCustomerNum = res.data.groupCustomerNum;
          }
        });
        operatingViewOperatorApi.getSixMonthChargeData(param).then((res) => {
          console.log(res);
          if (res.code === 0) {
            this.sixMonthData = res.data;
          }
        });
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.initCurrentMonth();
    },
    watch: {
      operatorSelectInput: function (val, oldVal) {
        if (val.length <= 0) {
          this.operatorsTemp = this.operators.slice(0,10)
        } else {
          this.operatorsTemp = []
          this.operators.forEach((item, index) => {
            if (item.name.indexOf(val) >= 0) {
              this.operatorsTemp.push(item)
            }
          })
        }
      }
    },
    // 挂载结束状态(里面是操作)
    mounted() {
      this.getRingStatistics()
      this.loadOperators()
      this.getOperatorsTree()
    },
    beforeUpdate: function () {
      this.getRing()
      this.getCharge()
      this.getIncome()
      this.getFault()
    }
  }
</script>

<style scoped>
  .fontcCloor {
    color: white;
    font-size: 25px;
    text-align: left;
    margin: 20px 0px 0px 20px;
  }

  .fontSize {
    color: white;
    font-size: 12px;
    text-align: left;
    margin: 5px 0px 25px 20px;
  }

  .fontStyle_one {
    color: white;
    font-size: small;
  }

  .fontStyle_four {
    font-size: small;
  }

  .fontStyle_five {
    font-size: 20px;
    margin-top: 5px;
  }

  .fontStyle_two {
    color: white;
    font-size: 20px;
    margin-top: 5px;
  }

  .fontStyle_three {
    margin: 10px 20px 0px 20px;
  }

  .div_style {
    float: left;
    width: 31%;
    height: 100px;
    margin: 0px 10px 10px 0px
  }

  .div_margin {
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .div_bule {
    background-color: #409EFF;
  }

  .div_green {
    background-color: #43c26e;
  }

  .div_Orange {
    background-color: #ffbc2e;
  }

  .div_red {
    background-color: #FF6640;
  }

  .div_purple {
    background-color: #C640FF;
  }

  .div_skyblue {
    background-color: #36f3ff;
  }

  .span_green {
    color: #43c26e;
    font-weight: bold
  }

  .span_red {
    color: #c22d1b;
    font-weight: bold
  }

  .span_margin {
    margin-left: 15px;
  }

  .div_style_one {
    float: left;
    width: 31%;
    height: 60px;
    margin: 0px 10px 10px 0px
  }

  .st-gbox {
    /*background-color: #fff;*/
    margin-top: 10px;
    border-radius: 5px;
    height: 30vh;
    box-sizing: border-box;
    padding: 10px;
  }

  .st-gbox_one {
    margin-left: 20px;
    height: 300px;
  }

  .st-gbox_two {
    height: 340px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .canvanbox {
    box-sizing: border-box;
    width: 100%;
    height: 300px;
  }

  .div_one {
    background-color: #F2F6FC;
  }

  .div_two {
    background-color: white;
  }

  .div_three {
    background-color: #EBEEF5;
    padding: 5px 0px 0px 10px;
    font-size: small;
  }

  .el_col_one {
    color: #B6B6C2;
    font-size: small;
  }

  .el_col_two {
    font-size: 30px;
    margin: 15px 0px 15px 0px;
  }

  .el_col_three {
    font-size: 30px;
    margin: 15px 0px 10px 0px;
  }
  .el_col_exit {
    font-size: 16px;
    margin: 15px 0px 10px 0px;
  }

  .el_col_four {
    color: #606266;
    font-size: small;
    margin-bottom: 15px;
  }

  .span_one {
    margin-right: 5px;
    font-size: 20px;
  }

  .h5_style {
    text-align: left;
    margin: 0px 0px 20px 18px;
    padding-top: 20px;
  }

  /deep/ .el-table .warning-row {
    background: oldlace;
  }

  /deep/ .el-table .success-row {
    background: #f0f9eb;
  }

  /deep/ .el-input__inner{
    background-color: rgb(8, 38, 58);
    border-radius:15px;
    border-color: rgb(8, 38, 58);
    color: #FFFFFF;
    font-size: large;
    font-weight: bold
  }



</style>



// WEBPACK FOOTER //
// src/module/monitoringCenter/page/operatingView_operator.vue